import React from "react";

const Table = ({ columns, data, onTrafficPercentageChange }) => {
  return (
    <div className="w-full max-w-full overflow-x-auto scrollbar scrollbar-thumb-insightful-purple scrollbar-track-insightful-lightest-gray">
      <table className="w-full max-w-full bg-white border border-gray-200">
        <thead className="w-full max-w-full">
          <tr className="max-w-full w-full">
            {columns.map((column) => (
              <th
                key={column.accessor}
                className="py-2 px-4 border-b border-gray-200 text-left text-gray-600"
              >
                {column.Header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="max-w-full w-full">
          {data &&
            data.map((row, rowIndex) => (
              <tr key={rowIndex} className="even:bg-gray-50 max-w-full w-full">
                {columns.map((column) => (
                  <td
                    key={column.accessor}
                    className="py-2 px-4 border-b border-gray-200 text-gray-800"
                  >
                    {column.accessor === "trafficPercentage" ? (
                      <input
                        type="text"
                        value={row.trafficPercentage}
                        onChange={(e) =>
                          onTrafficPercentageChange(rowIndex, e.target.value)
                        }
                        className="border p-1 w-full max-w-full"
                      />
                    ) : // Check if the content is a React element or a string
                    React.isValidElement(row[column.accessor]) ? (
                      row[column.accessor]
                    ) : (
                      row[column.accessor]
                    )}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
